export const KETRICS_LANGUAGES = [
  {
    key: "es",
    title: "Español",
    flag: "🇪🇸"
  },
  {
    key: "en",
    title: "Ingles",
    flag: "🇺🇸"
  }
];
